<p class="font-styling" *ngIf="hasSelectedPlans">
    Please carefully review the plans you have selected above for
    {{ quoteSummary?.company?.name }} before continuing. 
</p>
<ng-container *ngIf="isLoading">
    <div class="spinner">
        <mat-spinner [diameter]="60"></mat-spinner>
    </div>
</ng-container>

<table style="width:86%; padding-left:3px">
    <tr>
        <td>
            <div>
                <button mat-button (click)="cancelEnrollment()"> CANCEL </button>
            </div>
        </td>
        <td>
            <div align="end">
                <div>
                    <button mat-flat-button
                            *ngIf="!isLoading"
                            [disabled]="isDisabled"
                            [ngClass]="{
                                            'gray-color': !hasSelectedPlans,
                                            'blue-color': hasSelectedPlans
                                       }"
                            (click)="confirmEnrollment()">
                        NEXT
                    </button>
                </div>
            </div>
        </td>
    </tr>
</table>
